<template>
    <div v-if="isModalOpen">
        <div class="modal-backdrop fade in"></div>
        <!-- Modal -->
        <div class="modal fade in" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-center">
                        <h2 class="congrats">
                            {{'Congratulations!'|trans }}
                        </h2>
                        <h4>
                            {{'You have reached the level'|trans}} {{ currentBadge.name }}
                        </h4>

                        <div class="text-center">
                            <img :src="getBadgeUrl()" width="350">
                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModalCongratulations()">{{'Close'|trans}}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
	export default {
		components: {

        },
		props: {
			currentBadge : null,
            workerId: null
        },
        data() {
            return {
				isModalOpen: true
            }
        },
        created(){

		},
        methods: {
			async closeModalCongratulations() {
				await this.$api.worker.closeModalCongratulations(this.workerId);
				this.isModalOpen = false;
			},
			getBadgeUrl(){
				return process.env.VUE_APP_API_BASE_URL_ASSETS + "/images/badges/" + this.currentBadge.img_name;
			},
        },
        computed: {

        },
    }

</script>

<style scoped>
    .congrats{
        color: #9ed312;
        font-weight: bold;
    }
   .modal{
       display: block;
   }
   .modal-dialog{
       margin:0;
       width: 100%;
   }
</style>
